var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-3"},[_vm._m(0),_vm._m(1),_vm._m(2),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go Back")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b',[_vm._v("Created by Lukas Genßler")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b',[_vm._v("Contact:")]),_vm._v(" lukas dot genssler at icloud dot com")])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('b',[_vm._v("GitHub:")]),_vm._v(" lgenssler")])
}]

export { render, staticRenderFns }